require('./rosterService');

angular.module('app.admin.rosters.rostersController', [
  'app.admin.rosters.rosterService'
])
  .controller('app.admin.rosters.rostersController', [
    '$scope',
    'app.admin.rosters.rosterService',
    function ($scope, roster) {
      "use strict";

      $scope.leagues = null;
      $scope.teams = null;
      $scope.roster = null;

      $scope.selectedLeague = null;
      $scope.selectedTeam = null;

      $scope.getRoster = function () {
        roster.getRoster($scope.selectedTeam)
          .then(function (response) {
            $scope.roster = response.data.roster;
          });
      };

      $scope.getTeams = function () {
        roster.getTeams($scope.selectedLeague).then(
          function (response) {
            $scope.teams = response.data;

            if (Array.isArray($scope.teams)) {
              if ($scope.teams.length === 1) {
                $scope.selectedTeam = $scope.teams[0].iteamid;
                $scope.getRoster();
              }
            }
          }
        )
      };

      $scope.toggle = function (player, field, value) {
        let params = {};
        params[field] = value;
        roster.updateRoster(player.irosterid, params)
          .then(
            function (response) {
              let data = response.data;

              if (data.error) {
                if (data.roster) {
                  player[field] = data.roster[field];
                }
                alert(data.error);
              }
              else {
                player[field] = data[field];
              }
            }
          );
      };

      roster.getLeagues().then(
        function (response) {
          $scope.leagues = response.data;

          if (Array.isArray($scope.leagues)) {
            if ($scope.leagues.length === 1) {
              $scope.selectedLeague = $scope.leagues[0].ileagueid;
              $scope.getTeams();
            }
          }
        }
      )
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/rosters/rostersController.js